<div class="pay-now-container">
  <div class="pay-now-grid">

    <div class="details-column">

      <div class="section-card personal-details">
        <div class="section-header">
          <i class="pi pi-user section-icon"></i>
          <h3>Personal Details</h3>
        </div>
        <form [formGroup]="payNowForm" class="form-content">
          <div class="field">
            <label for="fullName">Full Name <span class="required">*</span></label>
            <input
              pInputText
              id="fullName"
              formControlName="fullName"
              placeholder="Enter your full name"
              [ngClass]="{'ng-invalid ng-dirty': payNowForm.get('fullName')?.invalid && (payNowForm.get('fullName')?.touched || formSubmitted)}"
            />
            <small class="p-error" *ngIf="payNowForm.get('fullName')?.hasError('required') && (payNowForm.get('fullName')?.touched || formSubmitted)">
              Full name is required
            </small>
          </div>

          <div class="field">
            <label for="emailAddress">Email Address <span class="required">*</span></label>
            <input
              pInputText
              id="emailAddress"
              type="email"
              formControlName="emailAddress"
              placeholder="your@email.com"
              [ngClass]="{'ng-invalid ng-dirty': payNowForm.get('emailAddress')?.invalid && (payNowForm.get('emailAddress')?.touched || formSubmitted)}"
            />
            <small class="p-error" *ngIf="payNowForm.get('emailAddress')?.hasError('required') && (payNowForm.get('emailAddress')?.touched || formSubmitted)">
              Email address is required
            </small>
            <small class="p-error" *ngIf="payNowForm.get('emailAddress')?.hasError('email') && (payNowForm.get('emailAddress')?.touched || formSubmitted)">
              Please enter a valid email address
            </small>
          </div>

          <div class="field">
            <label for="contactNumber">Contact Number <span class="required">*</span></label>
            <div class="phone-input-group">
              <span class="country-code">IN +91</span>
              <input
                pInputText
                id="contactNumber"
                formControlName="contactNumber"
                placeholder="Enter 10-digit mobile number"
                maxlength="10"
                (input)="formatPhoneNumber($event)"
                [ngClass]="{'ng-invalid ng-dirty': payNowForm.get('contactNumber')?.invalid && (payNowForm.get('contactNumber')?.touched || formSubmitted)}"
              />
            </div>
            <small class="p-error" *ngIf="payNowForm.get('contactNumber')?.hasError('required') && (payNowForm.get('contactNumber')?.touched || formSubmitted)">
              Contact number is required
            </small>
            <small class="p-error" *ngIf="payNowForm.get('contactNumber')?.hasError('pattern') && (payNowForm.get('contactNumber')?.touched || formSubmitted)">
              Please enter a valid 10-digit mobile number
            </small>
          </div>

          <div class="field">
            <label for="billingAddress">Billing Address <span class="required">*</span></label>
            <input
              pInputText
              id="billingAddress"
              formControlName="billingAddress"
              placeholder="Enter complete billing address"
              [ngClass]="{'ng-invalid ng-dirty': payNowForm.get('billingAddress')?.invalid && (payNowForm.get('billingAddress')?.touched || formSubmitted)}"
            />
            <small class="p-error" *ngIf="payNowForm.get('billingAddress')?.hasError('required') && (payNowForm.get('billingAddress')?.touched || formSubmitted)">
              Billing address is required
            </small>
          </div>
        </form>
      </div>

      <div class="section-card package-promo">
        <div class="section-header">
          <i class="pi pi-box section-icon"></i>
          <h3>Package & Promo Code</h3>
        </div>
        <form [formGroup]="payNowForm" class="form-content">
          <div class="field">
            <label for="selectedPackage">Select Package <span class="required">*</span></label>
            <p-dropdown
              id="selectedPackage"
              formControlName="selectedPackage"
              [options]="packages"
              optionLabel="label"
              optionValue="value"
              (onChange)="onPackageChange($event)"
              placeholder="Select a package"
              [ngClass]="{'ng-invalid ng-dirty': payNowForm.get('selectedPackage')?.invalid && (payNowForm.get('selectedPackage')?.touched || formSubmitted)}"
            ></p-dropdown>
            <small class="p-error" *ngIf="payNowForm.get('selectedPackage')?.hasError('required') && (payNowForm.get('selectedPackage')?.touched || formSubmitted)">
              Please select a package
            </small>
          </div>

          <div class="field">
            <label for="promoCode">Promo Code / Referral Code</label>
            <div class="promo-input-group">
              <input
                pInputText
                id="promoCode"
                formControlName="promoCode"
                placeholder="Enter code"
                [ngClass]="{'ng-invalid ng-dirty': promoError}"
              />
              <p-button
                *ngIf="!discountApplied"
                [label]="isValidatingPromo ? '...' : 'Apply'"
                (onClick)="applyPromoCode()"
                styleClass="apply-btn"
                [disabled]="!payNowForm.get('promoCode')?.value?.trim() || isValidatingPromo"
              ></p-button>

              <p-button
                *ngIf="discountApplied"
                label="Remove"
                (onClick)="removePromoCode()"
                styleClass="remove-btn"
              ></p-button>
            </div>
            <small class="p-error block mt-1" *ngIf="promoError">
              {{ promoError }}
            </small>

            <small class="text-green-600 block mt-1" *ngIf="discountApplied">
              Coupon applied successfully!
            </small>
          </div>
        </form>
      </div>

    </div>
    <div class="summary-column">
      <div class="section-card order-summary">
        <div class="section-header">
          <i class="pi pi-file section-icon"></i>
          <h3>Order Summary</h3>
        </div>
        <div class="summary-content">
          <div class="empty-state" *ngIf="!hasSelectedPackage">
            <i class="pi pi-box empty-icon"></i>
            <p class="empty-message">Select a package to see details</p>
          </div>

          <ng-container *ngIf="hasSelectedPackage">
            <div class="package-info">
              <h4 class="package-name">{{ selectedPackage!.label.split(' - ')[0] }}</h4>
              <div class="text-sm font-medium mb-3" style="color: #6c757d;">
                <i class="pi pi-tag" style="font-size: 0.875rem; margin-right: 4px;"></i>
                <span>{{ selectedPackage!.categoryName }}</span>
              </div>
              <p class="package-description" [innerHTML]="selectedPackage!.description"></p>
              <span class="duration-badge">{{ selectedPackage!.duration }}</span>
            </div>

            <div class="services-included">
              <h5>Services Included</h5>
              <ul class="services-list">
                <li *ngFor="let service of selectedPackage!.services">
                  <i class="pi pi-check-circle check-icon"></i>
                  <span>{{ service }}</span>
                </li>
              </ul>
            </div>

            <div class="price-breakdown">
              <div class="price-row">
                <span>Package Amount</span>
                <span class="price">₹{{ formatINR(selectedPackage!.price) }}</span>
              </div>
              <div class="price-row" *ngIf="discountApplied" style="color: green;">
                <span>Discount</span>
                <span class="price">- ₹{{ formatINR(discountAmount) }}</span>
              </div>
              <div class="price-row">
                <span>GST (18%)</span>
                <span class="price">₹{{ formatINR(gstAmount) }}</span>
              </div>
              <div class="price-row total">
                <span class="total-label">Total Amount <small>(incl. GST)</small></span>
                <span class="total-price">₹{{ formatINR(totalAmount) }}</span>
              </div>
            </div>

            <p-button
              label="Pay ₹{{ formatINR(totalAmount) }}"
              icon="pi pi-credit-card"
              (onClick)="onSubmit()"
              styleClass="pay-button"
              [disabled]="payNowForm.invalid"
            ></p-button>

            <p class="terms-text">
              By proceeding, you agree to our Terms & Conditions
            </p>
          </ng-container>
        </div>
      </div>
    </div>
    </div>
</div>
